import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  categorySlug: string;
  imageUrl: string;
  tags: string[];
  author: string;
  date: string;
  readTime: string;
}

export default function ArticleCard({
  slug,
  title,
  excerpt,
  category,
  categorySlug,
  imageUrl,
  tags,
  author,
  date,
  readTime,
}: ArticleCardProps) {
  return (
    <article className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300">
      <Link to={`/article/${slug}`} className="block">
        <div className="relative w-full h-52 overflow-hidden bg-background-100">
          <img
            src={imageUrl}
            alt={title}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute top-3 left-3">
            <Link
              to={`/category/${categorySlug}`}
              onClick={(e) => e.stopPropagation()}
              className="px-3 py-1 text-xs font-medium rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              {category}
            </Link>
          </div>
        </div>
      </Link>
      <div className="p-5">
        <Link to={`/article/${slug}`} className="block group/title">
          <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2 group-hover/title:text-primary-600 transition-colors line-clamp-2 leading-snug">
            {title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-500 mb-3 line-clamp-2 leading-relaxed">
          {excerpt}
        </p>
        <div className="flex flex-wrap gap-1.5 mb-3">
          {tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="px-2 py-0.5 text-xs rounded-md bg-background-100 text-foreground-600 whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>
        <div className="flex items-center justify-between text-xs text-foreground-400">
          <div className="flex items-center gap-3">
            <span className="flex items-center gap-1">
              <i className="ri-user-line"></i>
              {author}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-time-line"></i>
              {readTime}
            </span>
          </div>
          <span>{date}</span>
        </div>
      </div>
    </article>
  );
}